import { Component, Inject, Injector, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule,JkBaseOption, JkDialogEditComponent, jkRestReturn, JkImageViewerComponent, JktextareaComponent } from 'jk-service';
import { JackBaseComponentModule, MilkdownMarkdownEditorComponent } from 'jk-service';
import { AdvComModule } from "jk-advcom";
import { SysshService, templateUrlConfigSys } from '../_service_sys';
import { Syssh } from '../_entity_sys';


@Component({
  selector: 'app-syssh-edit',
  templateUrl: './syssh-edit.component.html',
  styleUrls: [],
  standalone: true,
  imports: [JackBaseComponentModule, AdvComModule,
    MilkdownMarkdownEditorComponent,
    JkImageViewerComponent,
    JktextareaComponent,
    MaterialModule],
})

export class SysshEditComponent extends JkDialogEditComponent<SysshService,Syssh>{
  readonly textContent = signal('');
  readonly imageUrl = signal('');
  override srv!: SysshService;
  constructor(
    inject: Injector,
    public override dialogRef: MatDialogRef<SysshEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(inject,dialogRef,data);
  }

  private async loadPreview(kind:string,data:string): Promise<void> {
    this.textContent.set('');
    this.imageUrl.set('');
      if (kind === 'markdown' || kind === 'text') {
        this.textContent.set(data); // new TextDecoder('utf-8').decode(data)
      } else if (kind === 'image') {
        const url = URL.createObjectURL(new Blob([data], { type: this.imageMime(data) }));
        this.imageUrl.set(url);
      }

  }
  private imageMime(name: string): string {
    const extension = name.split('.').pop()?.toLowerCase();
    return extension === 'svg' ? 'image/svg+xml' : extension === 'jpg' ? 'image/jpeg' : `image/${extension || 'png'}`;
  }

}
